---
title: Catch Log Guide
description: What to record in a fishing catch log so each trip helps you learn faster over time.
---

# Catch Log Guide

A good catch log should help you remember what happened without making fishing feel like paperwork.

## What to log

- Species and size if you know them.
- Photos and notes.
- Time, location context, and conditions.
- Gear, bait, lure, or rig.
- Weather, wind, tide, water clarity, and habitat clues.

## Why it helps

Fishing patterns are rarely obvious in the moment. A catch log gives you a way to compare trips and notice what keeps showing up.

## Capt'n's Log in Roddo

Capt'n's Log is built to save the story of each trip while still keeping the useful details close enough to learn from later.

---

### Keep learning

- [Best fishing log app](/learn/best-fishing-log-app)
- [FishIQ guide](/learn/fishiq)
